import React, {useEffect, useState} from 'react';
import {HttpStatus} from "../../../../modules/common/enums/HttpStatus";
import PaginationBar from "../../../../components/PaginationBar";
import {useIntl} from "react-intl";
import {PaginationDto} from "../../../../modules/common/dto/PaginationDto";
import {RequestVisitorSearchCondition} from "../../../../modules/vms/dto/RequestVisitorSearchCondition";
import {RequestVisitorApi} from "../../../../modules/vms/api/RequestVisitorApi";
import {RequestVisitorDto} from "../../../../modules/vms/dto/RequestVisitorDto";
import SearchCondition from "./components/SearchCondition";
import SearchResult from "./components/SearchResult";
import {Grid, Paper} from "@mui/material";
import {VisitRequestClassify} from "../../../../modules/vms/enums/VisitRequestClassify";
import PageTitle from "../../../../components/PageTitle";
import dayjs from "dayjs";
import {Formats} from "../../../../constants/Formats";
import RequestVisitorDetailDialog from "../../components/RequestVisitorDetailDialog";
import {MessageUtils} from "../../../../utils/MessageUtils";

// 倒计时
let secondsInterval: NodeJS.Timeout;
// 扫码枪用到的变量
let code = "";
let lastTime = 0;
let nextTime = 0;
let lastCode = 0;
let nextCode = 0;

let requestDialogOpen = false;

const Index: React.FC = () => {

    const intl = useIntl();

    // 查询条件
    const [searchCondition, setSearchCondition] = useState(new RequestVisitorSearchCondition());

    // 查询结果
    const [searchResult, setSearchResult] = useState(new Array<RequestVisitorDto>());

    // 分页数据
    const [pagination, setPagination] = useState(new PaginationDto());

    const [openVisitorDetailModal, setOpenVisitorDetailModal] = useState(false);

    const [requestVisitor, setRequestVisitor] = useState(new RequestVisitorDto());

    useEffect(() => {
        const searchCondition = new RequestVisitorSearchCondition();
        searchCondition.requestClassify = VisitRequestClassify.Enum.Visitor;
        searchCondition.arriveDateFrom = dayjs().format(Formats.DATE_SIMPLE);
        searchCondition.arriveDateTo = dayjs().format(Formats.DATE_SIMPLE);
        setSearchCondition(searchCondition);
        _handleSearch(searchCondition);

        // 监听键盘事件以实现扫码直接签到
        window.addEventListener('keypress', _handleScanWrapper, false);

        // 定时刷新页面
        secondsInterval = setInterval(() => {
            _handleSearch(searchCondition);
        }, 60000);
        // 画面退出销毁倒计时
        return () => {
            window.removeEventListener('keypress', _handleScanWrapper, false);
            if (secondsInterval) {
                clearInterval(secondsInterval);
            }
        }
    }, []);

    const _handleScanWrapper = (e: KeyboardEvent) => {
        console.log(e);
        // e.which拿到的是keyCode
        nextCode = e.which;
        nextTime = new Date().getTime();

        if (lastCode != null && lastTime != null && nextTime - lastTime <= 500) {
            //时间短为扫码枪
            code += String.fromCharCode(lastCode);
        } else if (lastCode != null && lastTime != null && nextTime - lastTime > 500) {
            //普通手动键盘输入
            code = "";
        }
        console.log(code);

        lastCode = nextCode;
        lastTime = nextTime;
        //是否点击Enter键
        if (e.which === 13) {
            // code = "2ca0e63fc95b47c99c196835e009b93d";
            // 因为回车符不是""，会导致后台服务被调用，所以加上trim方法过滤掉再判断
            if (code !== "") {
                // if (_checkVisitCode(code.trim())) {
                if (code.length === 6) {
                    // const decoded = atob(code);
                    // console.log(decoded);
                    // const visitCode = decoded.substring(0, 6);
                    // console.log(visitCode);
                    // const generateTimeStr = decoded.substring(6, 20);
                    // console.log(generateTimeStr);
                    //
                    // const now = dayjs();
                    // const generateTime = dayjs(generateTimeStr, Formats.DATE_TIME_SIMPLE);
                    //
                    // // 使用diff方法计算两个时间点之间的差异（以分钟为单位）
                    // const minutesDifference = now.diff(generateTime, 'minute');
                    // if (minutesDifference <= 5) {
                        // 跟当前时间比，5分钟内有效
                        _handleVerify(code);
                    // } else {
                    //     MessageUtils.warning(intl.formatMessage({id: "VMS_REQUEST_VISITOR_VISIT_CODE_TIMEOUT"}));
                    // }

                } else if (code.length === 4) {
                    if (!requestDialogOpen) {
                        const searchCondition = new RequestVisitorSearchCondition();
                        searchCondition.requestClassify = VisitRequestClassify.Enum.Visitor;
                        searchCondition.arriveDateFrom = dayjs().format(Formats.DATE_SIMPLE);
                        searchCondition.arriveDateTo = dayjs().format(Formats.DATE_SIMPLE);

                        _handleCheckOut(code, searchCondition);
                    }
                }
            }
            //清空code
            code = "";
        }
    }

    const _checkVisitCode = (code: string) => {
        try {
            // Base64 解码
            const decoded = atob(code);
            console.log(decoded);
            if (code.trim().length === 6) {
                return true;
            } else {
                return false;
            }
        } catch (e) {
            return false;
        }
    }

    const _handleVerify = async (visitCode: string) => {
        if (visitCode) {
            const responseResult = await RequestVisitorApi.getAvailableVisitor(visitCode);
            if (responseResult.status === HttpStatus.SUCCESS) {
                setRequestVisitor(responseResult.data);
                setOpenVisitorDetailModal(true);
                requestDialogOpen = true;
            }
        }
    }

    const _handleCheckOut = async (accessCardNumber: string, searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.checkout("", accessCardNumber);
        if (responseResult.status === HttpStatus.SUCCESS) {
            MessageUtils.success(intl.formatMessage({id: "VMS_REQUEST_VISITOR_CHECKOUT_SUCCESS"}));
            _handleSearch(searchCondition);
        }
    }

    const _handleVisitorDetail = async (id: string) => {
        const responseResult = await RequestVisitorApi.getVisitorDetailById(id);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setRequestVisitor(responseResult.data);
            setOpenVisitorDetailModal(true);
            requestDialogOpen = true;
        }
    };

    const handleChangeCondition = (name: string, value: any) => {
        setSearchCondition({...searchCondition, [name]: value});
    };

    const _handleSearch = async (searchCondition: RequestVisitorSearchCondition) => {
        const responseResult = await RequestVisitorApi.queryRequestVisitors(searchCondition);
        if (responseResult.status === HttpStatus.SUCCESS) {
            setSearchResult(responseResult.data);
            setPagination(responseResult.pagination);
        }
    };

    const handlePagination = (page: number, pageSize: number) => {
        const newSearchCondition = Object.assign({}, searchCondition);
        newSearchCondition.currentPage = page;
        newSearchCondition.pageSize = pageSize;
        _handleSearch(newSearchCondition);
    };

    const _getInitSearchCondition = () => {
        const searchCondition = new RequestVisitorSearchCondition();
        searchCondition.requestClassify = VisitRequestClassify.Enum.Visitor;
        searchCondition.arriveDateFrom = dayjs().format(Formats.DATE_SIMPLE);
        searchCondition.arriveDateTo = dayjs().format(Formats.DATE_SIMPLE);
        setSearchCondition(searchCondition);
        return searchCondition;
    }

    return (
        <div>

            <RequestVisitorDetailDialog open={openVisitorDetailModal}
                                        onClose={() => {
                                            setOpenVisitorDetailModal(false);
                                            requestDialogOpen = false;
                                        }}
                                        requestVisitor={requestVisitor}
                                        onUpdatedVisitor={() => {
                                            const tempSearchCondition = _getInitSearchCondition();
                                            _handleSearch(tempSearchCondition)
                                        }}
                                        onRefreshVisitor={() => _handleVisitorDetail(requestVisitor.id)}
                                        displayPlaceSpecial={true}/>
            <PageTitle title={intl.formatMessage({id: 'VMS_VISIT_REQUEST_CLASSIFY_VISITOR'})}/>
            <Paper sx={{p: 1}}>
                <SearchCondition searchCondition={searchCondition}
                                 onChange={handleChangeCondition}
                                 onSearch={() => _handleSearch(searchCondition)}/>
            </Paper>

            <br/>

            <Paper sx={{p: 1}}>
                <Grid container columnSpacing={2} alignItems="center">

                    <Grid item xs={10}> <PaginationBar pagination={pagination} onChange={handlePagination}
                    /></Grid>
                    <Grid item xs
                          style={{textAlign: "right"}}>{intl.formatMessage({id: "VMS_VISIT_REQUEST_VISITOR_COUNT"})} : {pagination.recordSum}</Grid></Grid>
                <SearchResult searchResult={searchResult}
                              onClickDetail={(id) => _handleVisitorDetail(id)}
                              onSortSearch={(
                                  sortField, sortBy
                              ) => {
                                  const newSearchCondition = Object.assign({}, searchCondition);
                                  newSearchCondition.sortField = sortField;
                                  newSearchCondition.sortType = sortBy;
                                  setSearchCondition(newSearchCondition)
                                  _handleSearch(newSearchCondition)
                              }} onSearch={() => _handleSearch(searchCondition)}/>
            </Paper>
        </div>
    );
};

export default Index;
